module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.01798bc1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/style/iconfont/stroke7/fonts/Pe-icon-7-stroke.ttf?d7yf1v
// module id = 2222
// module chunks = 228